import { AppShellContent, Banner, Stack, Text, Title } from "@assetwatch/ui";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { HomeScreen } from "../screens/HomeScreen";

function FieldopsHomeRoute() {
  const [bannerVisible, setBannerVisible] = useState(true);

  return (
    <AppShellContent
      banner={
        bannerVisible ? (
          <Banner
            icon="circle-info"
            onDismiss={() => setBannerVisible(false)}
            title="Field Ops is ready for page-level content."
            tone="informative"
          />
        ) : undefined
      }
      pageHeader={
        <Stack gap={8}>
          <Title size="lg">Field Ops</Title>
          <Text tone="subtle">
            The banner and page header sit above this route’s padded content.
          </Text>
        </Stack>
      }
    >
      <HomeScreen />
    </AppShellContent>
  );
}

export const Route = createFileRoute("/_app/")({
  component: FieldopsHomeRoute,
});
